import SnackbarMessage from "components/SnackbarMessage";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useState } from "react";
import { useIntl } from "react-intl";
import { ResourceRequestV2, ResourceV2 } from "services/KnowfullyAdminClient";
import { Mode, SnackbarMessageProps } from "types/common-types";
import translateError from "utils/translateError";
import ResourceForm from "./ResourceForm";

type ResourceUpdateFormProps = {
  resource: ResourceV2;
  onResourceUpdated: () => void;
  onCancel: () => void;
};

const ResourceUpdateForm = ({
  resource,
  onResourceUpdated,
  onCancel,
}: ResourceUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { resourceService } = useGlobalContext();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);

  const onSubmit = async (values: ResourceRequestV2) => {
    try {
      var response = await registerPromise(
        resourceService.saveResource(
          ResourceRequestV2.fromJS({
            id: resource.id!,
            mediaLibraryId: values?.mediaLibraryItemId,
            ...values,
          })
        )
      );
      onResourceUpdated();

      setSnackbarMessage(new SnackbarMessageProps(t({ id: "facultyUpdated" })));
      return response;
    } catch (err: any) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <ResourceForm
        resource={resource}
        onSubmit={onSubmit}
        submitLabel={t({ id: "facultyFormUpdateButton" })}
        onCancel={onCancel}
        mode={Mode.Update}
      />

      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </>
  );
};

export default ResourceUpdateForm;
